// Vue directive for Bootstrap-compatible dropdowns without jQuery
// Uses same HTML structure and CSS as Bootstrap 3
// Usage: <a v-dropdown href="#">Toggle</a> (on the toggle element inside .dropdown)

let openDropdown = null

// Close dropdown when clicking outside or selecting a menu item
document.addEventListener('click', e => {
  if (!openDropdown) return

  const clickedToggle = e.target.closest('[data-vue-dropdown]')
  const clickedMenuItem = e.target.closest('.dropdown-menu a, .dropdown-menu button')

  // Don't close if clicking the toggle (handled by toggle logic)
  if (clickedToggle) return

  // Close if clicking a menu item or outside the dropdown
  if (clickedMenuItem || !e.target.closest('.dropdown-menu')) {
    closeDropdown()
  }
})

// Close dropdown on escape key
document.addEventListener('keydown', e => {
  if (e.which === 27 && openDropdown) {
    const toggle = openDropdown.querySelector('[data-vue-dropdown]')
    closeDropdown()
    toggle?.focus()
  }
})

// Keyboard navigation within dropdown menu
document.addEventListener('keydown', e => {
  if (!openDropdown) return
  if (!/^(38|40)$/.test(e.which)) return
  if (/input|textarea/i.test(e.target.tagName)) return

  e.preventDefault()
  e.stopPropagation()

  const items = openDropdown.querySelectorAll('.dropdown-menu li:not(.disabled):not(.divider) a')
  if (!items.length) return

  let index = [...items].indexOf(document.activeElement)

  if (e.which === 38 && index > 0) index--
  if (e.which === 40 && index < items.length - 1) index++
  if (index < 0) index = 0

  items[index].focus()
})

const getDropdownParent = el => {
  let parent = el.parentElement
  while (parent) {
    if (parent.classList.contains('dropdown') || parent.classList.contains('dropup')) {
      return parent
    }
    parent = parent.parentElement
  }
  return el.parentElement
}

const closeDropdown = () => {
  if (!openDropdown) return

  openDropdown.classList.remove('open')
  const toggle = openDropdown.querySelector('[data-vue-dropdown]')
  toggle?.setAttribute('aria-expanded', 'false')
  openDropdown = null
}

const openDropdownEl = (dropdown, toggle) => {
  if (openDropdown && openDropdown !== dropdown) {
    closeDropdown()
  }

  dropdown.classList.add('open')
  toggle?.setAttribute('aria-expanded', 'true')
  openDropdown = dropdown
}

const handleClick = e => {
  const toggle = e.currentTarget
  const dropdown = getDropdownParent(toggle)

  if (toggle.classList.contains('disabled') || toggle.hasAttribute('disabled')) {
    return
  }

  e.preventDefault()

  const isOpen = dropdown.classList.contains('open')

  if (isOpen) {
    closeDropdown()
  } else {
    openDropdownEl(dropdown, toggle)
  }
}

// Vue 3 directive (exported for app.directive() registration)
export default {
  beforeMount(el) {
    el.setAttribute('data-vue-dropdown', '')
    el.setAttribute('aria-haspopup', 'true')
    el.setAttribute('aria-expanded', 'false')
    el.addEventListener('click', handleClick)
  },
  unmounted(el) {
    el.removeEventListener('click', handleClick)
    el.removeAttribute('data-vue-dropdown')
    const dropdown = getDropdownParent(el)
    if (openDropdown === dropdown) {
      closeDropdown()
    }
  }
}
